import { render, staticRenderFns } from "./verification-code.vue?vue&type=template&id=62d11772&scoped=true"
import script from "./verification-code.vue?vue&type=script&lang=js"
export * from "./verification-code.vue?vue&type=script&lang=js"
import style0 from "./verification-code.vue?vue&type=style&index=0&id=62d11772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d11772",
  null
  
)

export default component.exports